import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:3000';

/**
 * Get payment information for a reservation via token
 * @param {string} token - The unique payment token from the shareable link
 * @returns {Promise<Object>} Payment info including reservation details and payment progress
 */
export const getPaymentInfo = async (token) => {
  const response = await axios.get(`${API_URL}/payments/guest/${token}`);
  return response.data;
};

/**
 * Initiate a guest payment
 * @param {string} token - The unique payment token
 * @param {Object} data - Payment data
 * @param {number} data.guestCount - Number of guests to pay for
 * @param {string} [data.payerName] - Optional payer name
 * @param {string} [data.payerEmail] - Optional payer email
 * @param {string} [data.payerPhone] - Optional payer phone
 * @returns {Promise<Object>} Payment response with Paymob details
 */
export const initiateGuestPayment = async (token, data) => {
  const response = await axios.post(`${API_URL}/payments/guest/${token}/pay`, data);
  return response.data;
};

/**
 * Build the Paymob iframe URL from payment key
 * @param {string} paymentKey - The Paymob payment key
 * @returns {string} The iframe URL
 */
export const getPaymobIframeUrl = (paymentKey) => {
  const iframeId = process.env.REACT_APP_PAYMOB_IFRAME_ID || '841756';
  return `https://accept.paymob.com/api/acceptance/iframes/${iframeId}?payment_token=${paymentKey}`;
};

/**
 * Format amount from cents to display value
 * @param {number} cents - Amount in cents
 * @returns {string} Formatted amount (e.g., "100.00")
 */
export const formatAmount = (cents) => {
  return (cents / 100).toFixed(2);
};
